import { hasOwnMetadata } from 'core-js/fn/reflect';

//const _import = require('./_import_' + process.env.NODE_ENV);
//首页模块
const Home = () => import('../views/Home/Index');
const Form = () => import('../views/Form/Index');
const Subject = () => import('../views/Subject/Index');
const Project = () => import('../views/Project/Index');
const ProjectAttend = () => import('../views/Project/Indexattend');
const Group = () => import('../views/Group/Index');

//Form模块
const Form_App = () => import('../views/Form/App');
const Form_New = () => import('../views/Form/New');
const Form_Edit = () => import('../views/Form/Edit');
const Form_Data = () => import('../views/Form/Data');
const Form_Grid = () => import('../views/Form/Grid');

//Subject模块
const Patient = () => import('../views/Subject/patient');

const Subject_App = () => import('../views/Subject/App');
const Subject_FormInput = () => import('../views/Subject/FormInput');
const Subject_New = () => import('../views/Subject/New');
const Subject_Edit = () => import('../views/Subject/Edit');
const Subject_FormAdd = () => import('../views/Subject/SubjectFormAdd');
const Subject_Form = () => import('../views/Subject/form');


//Project模块
const Project_App = () => import('../views/Project/App');
const Project_New = () => import('../views/Project/New');
const Project_Edit = () => import('../views/Project/Edit');
const Project_Form = () => import('../views/Project/form');


//Group



//个人中心
const User_App = ()=>import('../views/User/App');
const User_Profile = ()=>import('../views/User/Profile');
const User_ChangePwd =() => import('../views/User/changepwd')
const User_WorkCard =() => import('../views/User/workcard')


const Routers = [
    {
        path:'/',
        redirect: '/home/subject'
    },
    {
        path: '/home',
        component: Home,
        children: [
            {
                name: 'home-form',
                path: 'form',
                component: Form
            },
            {
                name: 'home-subject',
                path: 'subject',
                component: Subject
            },
            {
                name: 'home-project',
                path: 'project',
                component: Project
            },
            {
                name: 'home-projectattend',
                path: 'projectattend',
                component: ProjectAttend
            },
            {
                path: 'patient',
                component: Patient
            },
            {
                path:'subjectform',
                name: 'home-subjectform',
                component:Subject_Form
            },
            {
                path:'projectform',
                name: 'home-projectform',
                component:Project_Form
            },
            {
                path:'group',
                name: 'home-group',
                component:Group
            },
        ]
    },
    {
        path:'/form',
        component:Form_App,
        children: [
            {
                name: 'form-new',
                path: 'new',
                component: Form_New
            },
            {
                name: 'form-edit',
                path: 'edit',
                component: Form_Edit
            },
            {
                name: 'form-data',
                path: 'data',
                component: Form_Data
            },
            {
                name: 'form-grid',
                path: 'grid',
                component: Form_Grid
            }
        ]
    },
    {
        path:'/subject',
        name: 'subject',
        component:Subject_App,
        children:[
            {
                path:'forminput',
                name: 'forminput',
                component:Subject_FormInput
            },
            {
                path:'new',
                name: 'subject-new',
                component:Subject_New
            },
            {
                path:'edit',
                name: 'subject-edit',
                component:Subject_Edit
            },
            {
                path:'subjectformadd',
                name: 'subject-formadd',
                component:Subject_FormAdd
            },
           
        ],
    },
   
    {
        path:'/project',
        component:Project_App,
        children: [
            {
                name: 'project-new',
                path: 'new',
                component: Project_New
            },
            {
                name: 'project-edit',
                path: 'edit',
                component: Project_Edit
            }
        ]
    },

    {
        path:'/user',
        component:User_App,
        children:[
            {
                path:'profile',
                component:User_Profile,
            },
            {
                path:'changepwd',
                component:User_ChangePwd,
            },
            {
                path:'workcard',
                component:User_WorkCard,
            },
        ]
    }
]

export default Routers